import axios from 'axios';

export default {
    async paginatedList({ page, vendor }) {
        if (!page)
            page = 1;

        let vendor_id = (vendor) ? vendor.id : null;

        let response = await axios.get('/api/orders', { params: { page, vendor_id } });
        return response.data;
    },
    async get(id) {
        let response = await axios.get(`/api/orders/${id}`);
        return response.data.data;
    },
    async update(order) {
        let response = await axios.patch(`/api/orders/${order.id}`, order);
        return response.data.data;
    },
}
